<template>
    <div class="d-flex flex-row justify-content-center details-content">
        <div id="company-container">
            <div id="company">
                <img :src="user.Logo" class="details-companyLogo"/>
            </div>
        </div>
        <div class="card shadow" id="details-main" v-if="user">
            <div class="card-header d-flex flex-row justify-content-between">
                <!-- <div class="d-flex flex-column justify-content-between align-items-end"> -->
                    <div class="d-flex flex-column align-items-start" id="person">
                        <div class="user-avatar" v-bind:style="{ 'background-image': 'url(\'' + user.Icon + '\')' }"></div>
                        <p class="name">{{ user.FirstName }} {{user.LastName}}</p>
                    </div>
                <!-- </div> -->
                <div id="company-phone-container">
                    <div id="company-phone">
                        <img :src="user.Logo" class="details-companyLogo"/>
                    </div>
                </div>
                <div class="row d-flex flex-column align-items-start" id="details">
                    <div class="infoitem">
                        <span><img class="icon" src="../assets/icons8-organization-50.png"/></span>
                        <span>{{user.CompanyName}}</span>
                    </div>
                    <div class="infoitem">
                        <span><img class="icon" src="../assets/icons8-prize-50.png"/></span>
                        <span>{{user.Role}}</span>
                    </div>
                    <div class="infoitem">
                        <span><img class="icon" src="../assets/icons8-envelope-50.png"/></span>
                        <span>{{user.Email}}</span>
                    </div>
                    <div class="infoitem">
                        <span><img class="icon" src="../assets/icons8-city-50.png"/></span>
                        <span>{{user.City}}, {{user.State}}</span>
                    </div>
                    <div class="infoitem">
                        <span><img class="icon" src="../assets/icons8-cat-footprint-50.png"/></span>
                        <span>{{user.SpiritAnimal}}</span>
                    </div>
                    </div>
            </div>
            <div class="card-body">
                <p>{{user.Message}}</p>
                 <br/>
                <p>{{user.Description}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import firebase from '@/firebase/init'
export default {
    name: 'Details',
    data(){
        return{
            user: null
        }
    },
    created(){
         var thisObj = this
        firebase.auth().onAuthStateChanged((user)=>{
            if(!user){
                this.$router.push({name: 'Login'})
            }
            else{
                let ref = db.collection('users').where('UID', '==', user.uid)
                ref.get().then(snapshot=>{
                    snapshot.forEach(doc=>{
                        var data = doc.data()
                        if(data.OnBoardingCompleted === false || data.Approved === false){
                            thisObj.$router.push({name: 'Home'})
                        }
                    })
                })
            }
        })
        var user_id = this.$route.params.user_id
        var db = firebase.firestore()
        var storage = firebase.storage()
        var storageRef = storage.ref()
        var docRef = db.collection("users").doc(user_id)
        docRef.get().then(function(doc) {
            if (doc.exists) {
                var user = doc.data()
                if(user.OnBoardingCompleted == true){
                    
                    let logoRef = storageRef.child(user.Logo)
                    user.Logo = require('../assets/Spinner-1s-200px.gif')
                    if(logoRef.location.path !== ""){
                        logoRef.getDownloadURL().then(function(url) {
                            user.Logo = url
                        }).catch(function(error) {user.Logo = ''})
                    }
                    let avatarRef = storageRef.child(user.Icon)
                    //user.Icon = require("../assets/Spinner-1s-200px.gif")
                    if(avatarRef.location.path !== ""){
                        avatarRef.getDownloadURL().then(function(url) {
                            user.Icon = url
                        }).catch(function(error) {user.Icon = ''})
                    }
                    user.id = doc.id
                    thisObj.user = user
                }
            } else {
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });
    },
    beforeCreate: function() {
            document.body.className = 'list'
            this.$parent.showNavbar = true
            this.$parent.showBackButton = true        
    }
}
</script>
<style scoped>
#details-main{
    width: 35%;
    /* margin: auto; */
    background-color: white !important;
}
#details{
    margin-top: 1em;
    margin-bottom: 1em;
}
.user-avatar{
    width: 7em;
    height: 7em;
    -webkit-border-radius: 60px;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 60px;
    -moz-background-clip: padding;
    border-radius: 60px;
    background-clip: padding-box;
    margin: 7px 0 0 5px;
    float: left;
    background-size: cover;
    background-position: center center;
}
.details-companyLogo{
    max-height: 100%;
    max-width: 100%;
}
.icon{
    height: 18px;
    margin-right: 1em;
}
.name{
    font-size: 1.3em;
    font-weight: bold;
    color: black;
    margin-bottom: 0;
    margin-left: 1em;
}
.card-body{
    padding: 2em;
    padding-top: 2em;
    padding-bottom: 1em;
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
}
.card-body p{
    white-space: pre-wrap;
    text-align: start !important;
}
.card-header span{
    font-size: 1em;
    font-weight: 500;
    color: #909090;
}
.card-header{
    padding: 2em 5em 0 2em;
    background-color: white;
    border-radius: 6px 6px 0px 0px !important;
}
.card{
    border-radius: 6px 6px 6px 6px !important;
    border: none;
}
.infoitem{
    margin-top: 0.5em;
    margin-left: 1em;
}
#company{
   width: 15em;
    height: 8em;
}
#company-phone{
    display: none;
}
/* @media (max-width: 1800px) {
    .user-avatar{
       height: 6em;
       width: 6em;
   }
   .card-header{
       padding: 2em 3em 0 3em;
   }
} */

@media (max-width: 1450px) {
    #details-main{
        width: 50%;
    }
    .card-header{
       padding: 2em 2em 0 2em;
   }
}
@media (max-width: 1200px) {
    #details-main{
        width: 55%;
    }
   .user-avatar{
       height: 6em;
       width: 6em;
   }
   .card-header{
       padding: 1.5em 3em 0 1.5em;
   }
}
@media (max-width: 1150px) {
    #details-main{
        width: 60%;
    }
   .user-avatar{
       height: 5em;
       width: 5em;
   }
   .card-header{
       padding: 2em 2em 0 2em;
   }
   #details{
       display: block;
       text-align: start;
   }
   
}
@media (max-width: 840px) {
    
   #details-main{
       width: 80%;
   }
   .card-header{
       padding: 2em 2em 0 2em;
   }
   #company-container, #company .details-companyLogo{
       display: none;
   }
   .details-content{
       margin: auto;
   }
   #company-phone{
       display: block !important;
        width: 10em;
        height: 5em;
        margin: 0.5em 0;
   }
   #company-phone-container{
        width: 100%;
        border-bottom: 1px solid rgba(0,0,0,.125);
        border-top: 1px solid rgba(0,0,0,.125);
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid rgba(0,0,0,.125);
        border-top: 1px solid rgba(0,0,0,.125);
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 1em 0;
        margin-top: 4em;
   }
   .card-header{
       display: block !important;
   }
   #person{
        flex-direction: row !important;
        align-items:stretch;
        display: inline !important;
        margin-bottom: 2em;
   }
   .name{
       padding-top: 1em;
   }
}
@media (max-width: 650px){
    #details-main{
       width: 90%;
   }
    .name{
       font-size: 1em;
       font-weight:500;
       margin-left: 0.5em;
       font-size: 1.3em;
       padding-top: 0.5em;
   }
   .user-avatar{
       height: 5em;
       width: 5em;
   }
   
   #person p{
       text-align: start;
       
   }
   
   #details{
       margin-top: 2em;
   }
   .user-avatar{
       margin-right: 2em;
       margin-top: 0;
       height: 4em;
       width: 4em;
   }
   #company-phone-container{
       margin-top: 2em;
   }
   #company-phone{
        width: 9em;
        height: 4em;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/Details.vue